module.exports = __webpack_public_path__ + "img/Grupo-38.7a02d842.svg";